import AutoReconcileModal from '@app/application/reconciliation/sections/auto-reconciliation/components/auto-reconcile-modal'
import AdjustmentsModal from '@app/application/adjustments/components/adjustments-modal.vue'
import autoReconcileCreateStoreFromData from '@app/application/reconciliation/sections/auto-reconciliation/utils/create-store-from-data'
import autoReconcileCreateStore from '@app/application/reconciliation/sections/auto-reconciliation/store'
import AccountsLockingModal from '@app/application/accounts/accounts-locking-modal.vue'
import InputAutomationSteps from '@app/application/ai_ocr_documents/components/input-automation-steps.vue'
import MarkProposalAsFinalizedModal from '@app/application/reconciliation/components/mark-proposal-as-finalized-modal'
import AcceptAllPulseChangesModal from '@app/application/workflows/components/accept-all-pulse-changes-modal'
import ShareWorkflowWithPulseUsersModal from '@app/application/pulse-share/share-workflow-with-pulse-users-modal'
import ConfirmDeleteSegmentModal from '@app/insights/components/segments/confirm-delete-segment-modal'
import FileFollowersModal from '@app/application/workflows/components/file-followers-modal.vue'
import ManageCompanyLinksModal from '@app/application/company_links/components/manage-company-links-modal'
import ExternalCompanySelectorModal from '@app/application/company_links/components/external-company-selector-modal'
import DeleteCompanyLinkModal from '@app/application/company_links/components/delete-company-link-modal'

export default [
  [
    'accounts-locking-modal',
    {
      component: AccountsLockingModal,
      meta: { singletonId: 'accounts-locking-modal' },
    },
  ],
  [
    'adjustments-modal',
    {
      component: AdjustmentsModal,
      meta: { singletonId: 'adjustments-modal' },
    },
  ],
  [
    'auto-reconcile-modal',
    {
      component: AutoReconcileModal,
      createStore: autoReconcileCreateStoreFromData(autoReconcileCreateStore),
      meta: { singletonId: 'auto-reconcile-modal' },
    },
  ],
  [
    'file-followers-modal',
    {
      component: FileFollowersModal,
      meta: { singletonId: 'file-followers-modal' },
    },
  ],
  [
    'mark-proposal-as-finalized-modal',
    {
      component: MarkProposalAsFinalizedModal,
      meta: { singletonId: 'mark-proposal-as-finalized-modal' },
    },
  ],
  [
    'accept-all-pulse-changes-modal',
    {
      component: AcceptAllPulseChangesModal,
      meta: { singletonId: 'accept-all-pulse-changes-modal' },
    },
  ],
  [
    'input-automation-steps-modal',
    {
      component: InputAutomationSteps,
      meta: { singletonId: 'input-automation-steps' },
    },
  ],
  [
    'share-workflow-with-pulse-users-modal',
    {
      component: ShareWorkflowWithPulseUsersModal,
      meta: { singletonId: 'share-workflow-with-pulse-users-modal' },
    },
  ],
  [
    'confirm-delete-segment-modal',
    {
      component: ConfirmDeleteSegmentModal,
      meta: { singletonId: 'confirm-delete-segment-modal' },
    },
  ],
  [
    'external-company-selector-modal',
    {
      component: ExternalCompanySelectorModal,
      meta: { singletonId: 'external-company-selector-modal' },
    },
  ],
  [
    'manage-company-links-modal',
    {
      component: ManageCompanyLinksModal,
      meta: { singletonId: 'manage-company-links-modal' },
    },
  ],
  [
    'delete-company-link-modal',
    {
      component: DeleteCompanyLinkModal,
      meta: { singletonId: 'delete-company-link-modal' },
    },
  ],
]
